import React from 'react';
import { connect } from 'react-redux';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';

import { updateCheckout, updatePayment } from 'actions/CheckoutActions';

class PaymentButton extends React.Component {
  render() {
    const {
      intl: { messages },
      ePaymentTotal,
      user,
      projectConfig,
      checkout,
    } = this.props;

    return <>Bill Button</>;
  }
}

export default PaymentButton;
